import { render, staticRenderFns } from "./General_img.vue?vue&type=template&id=0cb7dbf8"
import script from "./General_img.vue?vue&type=script&lang=js"
export * from "./General_img.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports